import script from "./InputPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./InputPassword.vue?vue&type=script&setup=true&lang=js"

import "./InputPassword.vue?vue&type=style&index=0&id=48a6e0ba&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48a6e0ba"]])

export default __exports__